<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <form v-on:submit.prevent="submitForm">
      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              OT Bill create
              <v-spacer></v-spacer>
            </v-card-title>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr class="heading">
                  <th width="70%">Ledger Head</th>
                  <th width="30%">Amount</th>
                  <th width></th>
                </tr>
                </thead>
                <tbody>
                <tr
                    class="item"
                    v-for="(item, index) in ledgerHead"
                    :key="index"
                >
                  <td>{{ item.ledgerName }}</td>
                  <td class="text-right">
                    <v-text-field
                        label="Amount"
                        :rules="[numberRule]"
                        hide-details="auto"
                        v-model="item.amount"
                        :readonly="item.type === 'Lens'"
                    ></v-text-field>
                  </td>
                  <td class="text-right" v-if="item.type !== 'GeneralHead'">
                    <!-- Remove button for each IOL item -->
                    <v-btn color="error" x-small @click="removeBillHead(index)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-right" v-else-if="item.type === 'Cabin'">
                    <v-btn color="error" x-small @click="removeBillHead(index)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td>
                    Anesthesia Doctor Ledger
                    <v-col class="d-flex">
                      <v-autocomplete
                          clearable
                          deletable-chips
                          dense
                          v-model="anesthesiaDoctorName"
                          :items="sureonList"
                          label="Anesthesia Doctor"
                          single-line
                          item-text="dr_name"
                          item-value="id"
                      ></v-autocomplete>
                    </v-col>
                  </td>
                  <td class="text-right">
                    <v-text-field
                        label="Amount"
                        :rules="[numberRule]"
                        v-model="anesthesiaDoctorLedger"
                        hide-details="auto"
                        class="text-right"
                    ></v-text-field>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td class="text-right">Sub Total</td>
                  <td class="text-right">{{ subtotal | currency }}</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="text-right">Hospital Ledger</td>
                  <td class="text-right">{{ hospitalLedger | currency }}</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="text-right">Doctor Ledger</td>
                  <td class="text-right">{{ doctorLedger | currency }}</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="text-right">Total</td>
                  <td class="text-right">{{ total | currency }}</td>
                  <td></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-col class="text-right" cols="12">
              <div class="">
                <v-btn small color="primary" type="submit">Submit</v-btn>
              </div>
            </v-col>
          </v-card>
        </v-col>
        <v-col v-if="lensArea">
          <v-card cols="3">
            <v-card-title>
              OT Bill: Lens
              <v-spacer></v-spacer>
              <v-text-field v-model="search" dense outlined></v-text-field>
            </v-card-title>

            <v-data-table
                :headers="lensHeaders"
                :items="lensDataList"
                class="elevation-1"
                :search="search"
                dense
                :loading="loadingstatus"
                loading-text="Loading... Please wait"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn color="info" x-small @click="setLensDataGenerateHead(item)"
                >
                  <v-icon small> mdi-plus</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>
            </v-data-table>
          </v-card>
            <v-card>
              <v-card-title>
                OT Bill: Cabin List
                <v-spacer></v-spacer>
                <v-text-field v-model="search" dense outlined></v-text-field>
              </v-card-title>

              <v-data-table
                  :headers="cabinHeaders"
                  :items="cabinLists"
                  class="elevation-1"
                  :search="search"
                  dense
                  :loading="loadingstatus"
                  loading-text="Loading... Please wait"
              >
                <template v-slot:item.actions="{ item }">
                  <v-btn color="info" x-small @click="setCabinDataGenerateHead(item)"
                  >
                    <v-icon small> mdi-plus</v-icon>
                  </v-btn>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
        </v-col>
        <v-col cols="3">
          <v-card>
            <v-card-title>
              Invoice Details
              <v-spacer></v-spacer>
            </v-card-title>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">Invoice ID</th>
                  <th class="text-left">Paid Amount</th>
                  <th class="text-left">Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in invoices" :key="item.invoice_id">
                  <td>{{ item.invoice_id }}</td>
                  <td class="text-right">{{ item.paid_amount }}</td>
                  <td>{{ item.create_date }}</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <th class="text-right">{{ invoice_total | currency }}</th>
                  <td></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <v-card>
            <v-card-title>
              Surgery Info
              <v-spacer></v-spacer>
            </v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td>Name:</td>
                  <td class="">{{ operation.name }}</td>
                </tr>
                <tr>
                  <td>Eye Type:</td>
                  <td class="">{{ op_registration.eye_type }}</td>
                </tr>
                <tr>
                  <td>Operation Type:</td>
                  <td class="">{{ operation.op_type }}</td>
                </tr>
                <tr>
                  <td>Doctor:</td>
                  <td class="">{{ doctor.dr_name }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <v-card>
            <v-card-title>
              Patient Info
              <v-spacer></v-spacer>
            </v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td>Patient ID:</td>
                  <td class="">{{ patient_info.patient_id }}</td>
                </tr>
                <tr>
                  <td>Name:</td>
                  <td class="">{{ patient_info.patient_name }}</td>
                </tr>
                <tr>
                  <td>Age:</td>
                  <td class="">{{ patient_info.patient_age }}</td>
                </tr>
                <tr>
                  <td>Phone:</td>
                  <td class="">{{ patient_info.patient_phone }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </form>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";

export default {
  data() {
    return {
      patient_reg_no: this.$route.params.id,
      search: "",
      spinnerButtons: false,
      loadingstatus: false,
      headers: [
        {
          text: "Invoice ID",
          align: "start",
          value: "invoice_id",
        },
        {text: "Amoount", value: "paid_amount"},
        {text: "Date", value: "create_date"},
      ],
      invoices: [],
      errors: [],
      invoice_total: 0,
      ot_calculate: 40,
      ot_doctor: {},
      patient_info: {patient_name: null},
      doctor: {dr_name: null},
      operation: {name: null},
      op_registration: {patient_name: null},
      sureonList: [],
      anesthesiaDoctorName: null,
      anesthesiaDoctorLedger: 0,
      ot_operation_item: 0,
      ledgerHead: [
        {ledgerName: "Admission Fee", amount: 0, type: 'GeneralHead'},
        {ledgerName: "Anesthesia Amount", amount: 0, type: 'GeneralHead'},
        {ledgerName: "Medicine", amount: 0, type: 'GeneralHead'},
      ],

      lensArea: null,
      lensHeaders: [
        {
          text: "Brand",
          value: "name",
        },

        {
          text: "Model",
          value: "model_name",
        },
        {
          text: "Type",
          value: "lens_type",
        },
        {
          text: "Action",
          value: "actions",
        },
      ],
      lensDataList: [],
      cabinHeaders: [
        {
          text: "Name",
          value: "name",
        },

        {
          text: "Charge",
          value: "cabin_charge",
        },
        {
          text: "Action",
          value: "actions",
        },
      ],
      cabinLists: [],

      rules: [
        (value) => !!value || "Required.",
        (value) => (value && value.length >= 1) || "Min 3 characters",
      ],
      numberRule: (val) => {
        if (val < 0) return "Please enter a positive number";
        return true;
      },
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Ot Bill Generate",
          disabled: true,
          href: "patients",
        },
      ],
      apiPath: atshq.defaults.headers.common.app_URL,
      returnUrl: atshq.defaults.headers.common.app_URL,
      user_id: localStorage.getItem("userId"),
      local_ip_address: localStorage.getItem("local_ip_address"),
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
    this.getLensData();
    this.getCabinList();
  },
  methods: {
    initialize() {
      atshq
          .get("ot-bill/create?reg_id=" + this.patient_reg_no)
          .then((response) => {
            this.invoices = response.data.data.invoice_list;
            this.ot_doctor = response.data.data.op_registration.opp_doctor_id;
            this.ot_operation_item = response.data.data.op_registration.opp_opID;
            this.sureonList = response.data.data.doctorlist;
            this.operation = response.data.data.operation_details;
            this.op_registration = response.data.data.op_registration;
            this.doctor = response.data.data.doctor;
            this.patient_info = response.data.data.patient;
            this.lensArea = true;
            if (response.data.data.op_registration.opp_status == "close") {
              alert("Please check again, already generate ot Bill");
            }

            this.invoice_total = this.invoices.reduce(
                (acc, item) => acc + parseInt(item.paid_amount),
                0
            );
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },


    setLensDataGenerateHead(item) {
      let _lensData = {
        id: item.id,
        ledger_name:
            " Lens: " +
            item.name +
            " >> " +
            item.model_name +
            " >> " +
            item.brand.name,
        amount: item.sell_price,
        amount_fixed: 1,
      };
      this.ledgerHead.find(
          (entry) => entry.ledgerName === `${_lensData.ledger_name}`
      );
      // Add the lens item to the ledgerHead
      this.ledgerHead.push({
        ledgerName: `${_lensData.ledger_name}`,
        amount: item.sell_price,
        type: 'Lens',
      });
    },
    setCabinDataGenerateHead(item) {
      let cabinData = {
        id: item.id,
        ledger_name:
            " Cabin: " +
            item.name,
        amount: item.cabin_charge,
        amount_fixed: 1,
      };
      this.ledgerHead.find(
          (entry) => entry.ledgerName === `${cabinData.ledger_name}`
      );
      this.ledgerHead.push({
        ledgerName: `${cabinData.ledger_name}`,
        amount: item.cabin_charge,
        type: 'Cabin',
      });
    },
    removeBillHead(index) {
      this.ledgerHead.splice(index, 1);
    },

    getLensData() {
      atshq
          .get("lens/lens-active-list")
          .then((response) => {
            this.lensDataList = response.data.lensProducts;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getCabinList() {
      atshq
          .get("cabin/cabin-list")
          .then((response) => {
            this.cabinLists = response.data.cabinLists;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    submitForm() {
      if (
          0 < this.anesthesiaDoctorLedger &&
          this.anesthesiaDoctorName == null
      ) {
        alert("Please Select Anesthesia Doctor.");
        return false;
      }

      if (confirm("are you sure?")) {
        atshq
            .post("ot-bill", {
              formdata: this.form,
              items: this.ledgerHead,
              doctorLedger: this.doctorLedger,
              hosptial: this.hospitalLedger,
              op_reg_id: this.patient_reg_no,
              anesthesiaDoctor: this.anesthesiaDoctorName,
              anesthesiaDoctorLedger: this.anesthesiaDoctorLedger,
              user_id: localStorage.getItem("userId"),
            })
            .then((res) => {
              //Perform Success Action
              if (res.status == "200") {
                window.open(this.returnUrl + "printdoc/invoiceDoctorOt/" + res.data.data.op_reg_id);
                location.reload();
                alert('Successfuly create this ot bill');
              }
            })
            .catch((e) => {
              // error.response.status Check status code
              console.log(e)
              alert(e.messages);
              this.errors.push(e);
            })
            .finally(() => {
              //Perform action in always
            });
      }

    },
  },
  computed: {
    calculate_percent() {
      return 40; //new calculation deh satkhira ot bill generate 40% hospital & 60% doctor charge
      // return this.ot_doctor == 5 && (this.ot_operation_item == 104 || this.ot_operation_item == 105) ? 25 : 40;
    },
    subtotal() {
      return this.ledgerHead.reduce(
          (acc, item) =>
              acc + parseInt(item.amount), 0
      ) + parseFloat(this.anesthesiaDoctorLedger);

    },
    hospitalLedger() {
      return (
          ((this.invoice_total - this.subtotal) * this.calculate_percent) / 100
      );
    },
    doctorLedger() {
      return this.invoice_total - (this.subtotal + this.hospitalLedger);
    },
    total() {
      return this.invoice_total;
    },
  },
  filters: {
    currency(value) {
      var val = parseFloat(value)
      return val.toFixed(2);
    },
  },
};
</script>